import styles from './UnauthenticatedUserNavBar.module.css';
import { NavBarBase } from '../../NavBarBase/NavBarBase';
import { TelephoneNavItem } from '../../NavBarBase/TelephoneNavItem/TelephoneNavItem';

export const UnauthenticatedUserNavBar = () => {
  return (
    <NavBarBase>
      <div className={styles.innerContainer}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://support.iwoca.co.uk/en/collections/2145896-what-s-iwocapay"
          className={styles.faq}
        >
          FAQ
        </a>
        <div className={styles.navBarItem}>
          <TelephoneNavItem />
        </div>
      </div>
    </NavBarBase>
  );
};
